import React from 'react';
import { Layout } from '../components/Layout';
import { PlayIcon } from 'lucide-react';
export function Podcast() {
  const episodes = [{
    title: 'How To Live Authentically & Empower Yourself',
    guest: 'Chinaza Favour',
    description: 'A powerful conversation on authenticity and self-empowerment',
    videoId: 'pm8nxSA40aQ'
  }, {
    title: "Single Mom to Marketing Manager: Monica Inyang's Journey of Resilience and Success",
    guest: 'Monica Inyang',
    description: 'An inspiring story of resilience and professional growth',
    videoId: '9RlzHiLj6S0'
  }, {
    title: "From Struggles to Success: Elisha Mamman's Blueprint for Building a Meaningful Life",
    guest: 'Elisha Mamman',
    description: 'A blueprint for overcoming challenges and building purpose',
    videoId: 'zeFiEpmDi_s'
  }, {
    title: 'From Selling Bread to Building Leading Brands',
    guest: 'Somto Anekwe',
    description: "Somto's E-commerce Growth Journey",
    videoId: '1ZPwtQ1JyYk'
  }, {
    title: 'How Aproko Doctor is Saving Lives',
    guest: 'Aproko Doctor',
    description: 'The Power of Storytelling in Healthcare',
    videoId: 'Ex4HLtco4SA'
  }, {
    title: 'Mastering Financial Freedom',
    guest: 'Jennifer Awirigwe (Financial Jennifer)',
    description: 'A Fireside Chat on Financial Wisdom',
    videoId: 'vXYFq-MQsoE'
  }, {
    title: 'How To Become A High Value Individual',
    guest: 'Gusi Tobby',
    description: 'Building Character and Value',
    videoId: 'wDJSXbKzsYE'
  }];
  return <Layout data-id="element-345">
      <div className="max-w-7xl mx-auto px-6 py-16" data-id="element-346">
        {/* Header */}
        <div className="text-center mb-12" data-id="element-347">
          <div className="inline-flex items-center gap-2 bg-voices-red text-white px-4 py-2 rounded-full font-bold mb-4" data-id="element-348">
            <PlayIcon size={20} data-id="element-349" />
            PODCAST
          </div>
          <h1 className="text-5xl font-bold text-black mb-4" data-id="element-350">
            Voices with Victoria
          </h1>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-351">
            Faith-forward conversations that challenge, encourage, and equip
            young professionals and creatives to navigate life with purpose.
          </p>
        </div>
        {/* Episodes Grid */}
        <div className="space-y-12" data-id="element-352">
          {episodes.map((episode, index) => <div key={index} className="bg-white rounded-2xl shadow-xl overflow-hidden border-l-8 border-voices-gold" data-id="element-353">
              <div className="grid md:grid-cols-2 gap-0" data-id="element-354">
                {/* Video */}
                <div className="aspect-video bg-black" data-id="element-355">
                  <iframe width="100%" height="100%" src={`https://www.youtube.com/embed/${episode.videoId}`} title={episode.title} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen className="w-full h-full" data-id="element-356"></iframe>
                </div>
                {/* Episode Info */}
                <div className="p-8 flex flex-col justify-center" data-id="element-357">
                  <div className="text-voices-red font-bold mb-2" data-id="element-358">
                    EPISODE {index + 1}
                  </div>
                  <h2 className="text-3xl font-bold text-black mb-3" data-id="element-359">
                    {episode.title}
                  </h2>
                  <p className="text-xl text-voices-gold font-semibold mb-3" data-id="element-360">
                    with {episode.guest}
                  </p>
                  <p className="text-gray-700 text-lg" data-id="element-361">{episode.description}</p>
                </div>
              </div>
            </div>)}
        </div>
        {/* Subscribe CTA */}
        <div className="mt-16 bg-gradient-to-br from-voices-red to-red-700 text-white rounded-2xl p-12 text-center" data-id="element-362">
          <h2 className="text-4xl font-bold mb-4" data-id="element-363">Never Miss an Episode</h2>
          <p className="text-xl mb-8" data-id="element-364">
            Subscribe to our YouTube channel and get notified when new episodes
            drop.
          </p>
          <a href="https://youtube.com/@victoriandu?sub_confirmation=1" target="_blank" rel="noopener noreferrer" className="bg-white text-voices-red px-8 py-4 rounded-lg font-bold text-lg hover:bg-gray-100 transition-colors inline-block" data-id="element-365">
            Subscribe on YouTube
          </a>
        </div>
      </div>
    </Layout>;
}